module.exports = __webpack_public_path__ + "4f421a351775570966a1173c42335d1c.svg";